import Button from '@/components/units/button/Button';
import InvestmentCardField from '../InvestmentCardField';
import { Link } from 'react-router-dom';
import { useMemo } from 'react';

const IYICardContent = ({ data }) => {
  const investedAmount = useMemo(
    () => data?.reduce((sum, item) => sum + (item.ValueAtcost || 0), 0),
    [data]
  );

  const currentAmount = useMemo(
    () => data?.reduce((sum, item) => sum + (item.CurrentMarketValuation || 0), 0),
    [data]
  );

  const iyiReturnAmount = useMemo(() => {
    return data.reduce((sum, item) => {
      const value = item?.AbsoluteGainOrLoss;

      if (value == null) return sum;
      return sum + (typeof value === 'number' ? value : parseFloat(value));
    }, 0);
  }, [data]);

  const iyiDetails = {
    current: currentAmount?.toFixed(2),
    investment: investedAmount?.toFixed(2),
    unRealizedGainLoss: iyiReturnAmount?.toFixed(2),
    unRealizedGainLossPct: ((iyiReturnAmount / investedAmount) * 100).toFixed(2),
  };

  return (
    <div className="tw-pt-4 xs:tw-pt-10 tw-w-full tw-flex tw-flex-col xs:tw-gap-1 sm:tw-gap-2 tw-justify-between">
      <div className="tw-flex tw-flex-grow tw-flex-col xs:tw-flex-row tw-justify-between skeleton-block">
        <InvestmentCardField
          label="Current Value"
          primaryValue={iyiDetails?.current}
          withTypography
        />
        <InvestmentCardField
          label="Invested Value"
          primaryValue={iyiDetails?.investment}
          alignment="right"
        />
      </div>
      <div className="tw-flex tw-flex-grow tw-flex-col xs:tw-flex-row tw-justify-between skeleton-block">
        <InvestmentCardField
          label="Unrealized P/L"
          primaryValue={iyiDetails?.unRealizedGainLoss}
          secondaryValue={iyiDetails?.unRealizedGainLossPct}
          alignment="left"
        />
        {/* // TODO : FUTURE USE */}
        {/*  <InvestmentCardField label="XIRR" secondaryValue={iyiDetails.xirr} alignment="right" /> */}
      </div>
    </div>
  );
};

export default IYICardContent;
